const e164PhoneNumberRegex = /^\+?[1-9]\d{1,14}$/;
const swedishPhoneNumberRegex = /^(\+46|0)(\s?\d{1,3})[\s-]?\d{2,4}[\s-]?\d{2,4}[\s-]?\d{0,4}$/;

export function validatePhoneNumber(phoneNumber: string) {
  return e164PhoneNumberRegex.test(phoneNumber) || swedishPhoneNumberRegex.test(phoneNumber);
}
